import TotalSellComponent from "components/Reports/TotalSellComponent";
import Table from "components/Table";

const MyTotalSell = () => {
    return <TotalSellComponent isSell={true} type="sellByProducts" />;
};

export default function SellByProducts() {
    return (
        <div className="wrap-journal">
            <Table type="sellByProducts" sumAmountInfo={[
                { name: "saleQuantity", isCurrency: false },
                { name: "saleAmount", isCurrency: true },
                { name: "saleReturnsQuantity", isCurrency: false },
                { name: "saleReturnsAmount", isCurrency: true },
                { name: "saleReturnsDiscount", isCurrency: true },
                { name: "saleReturnsTax", isCurrency: true },
            ]} MidComponent={MyTotalSell as any} />
        </div>
    );
}
